import { render } from "./avatar1.vue?vue&type=template&id=bd03b86c"
const script = {}

import exportComponent from "/mnt/d/_projects/gitogram/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__